import { createAction } from 'redux-actions';
import * as c from '../../constants/constants';

export const setActiveOverviewChart = createAction(c.OVERVIEW_CHART_SET_ACTIVE, payload => payload);
export const setSortedOverviewChart = createAction(c.OVERVIEW_CHART_SET_SORTED, payload => payload);
export const setWindowOverviewChart = createAction(c.OVERVIEW_CHART_SET_WINDOW, payload => payload);
